<template>
  <Popup ref="popup" minHeight="100%" title="详细">
    <Content
      :top="50"
      :bottom="isLoading ? 0 : 76"
      @content-scroll="handleContentScroll"
    >
      <Loading v-if="showLoading" :isLoading="isLoading" @reload="showPopup" />
      <div class="title">
        <span>{{ detail.departName }}</span>
        <span>{{ detail.groupName }}</span>
      </div>
      <ul class="list">
        <li class="list-item list-title van-hairline--bottom">
          <span class="list-item__gsId">瓶号</span>
          <span class="list-item__residua-gas">介质</span>
          <span>
            <!-- <span>全选</span> -->
            <van-checkbox
              v-model="checkedAll"
              shape="square"
              @click="handleCheckedAllClick"
            />
          </span>
        </li>
        <van-checkbox-group v-model="checked" ref="checkboxGroup">
          <li
            class="list-item list-child"
            v-for="item in list"
            :key="item.gsCode"
          >
            <span
              :style="{ color: item.isOverdue === '1' ? 'red' : '' }"
              class="list-item__gsId"
              @click.stop="handleComClick(item)"
              >{{ item.gsCode
              }}{{ item.isOverdue === '1' ? '(超期)' : '' }}</span
            >
            <span class="list-item__residua-gas">{{ item.gsGoodsName }}</span>
            <span>
              <van-checkbox :name="item.gsCode" shape="square" />
            </span>
          </li>
        </van-checkbox-group>
      </ul>
      <loading-more
        :finished="finished"
        :showLoadingMore="showLoadingMore"
        :loadingFail="loadingFail"
        :list="list"
        @reload="getList"
      />
    </Content>
    <div class="btn-fixed">
      <van-button
        block
        type="primary"
        native-type="button"
        :loading="loading"
        :disabled="loading"
        @click="handleSubmitClick"
        v-if="!isLoading && list[0].isTest === '1'"
      >
        送检
      </van-button>
      <van-button
        block
        type="primary"
        native-type="button"
        :loading="loading"
        :disabled="loading"
        loading-text="请稍后..."
        @click="handleSubmitClick2"
        v-else
      >
        退出
      </van-button>
    </div>
    <!-- 选择退出原因 -->
    <van-overlay :show="show" @click="show = false" z-index="10">
      <div class="wrapper" v-if="show">
        <div class="block" @click.stop>
          <van-form @submit="onConfirm">
            <Picker
              label="退出原因 "
              :columns="columns"
              :border="false"
              :require="true"
              @confirm-values="(value) => (quitReason = value.dicVal)"
            />
            <div style="margin: 16px">
              <van-button round block type="primary" native-type="submit">
                确认
              </van-button>
            </div>
          </van-form>
        </div>
      </div>
    </van-overlay>
  </Popup>
</template>

<script>
import { Toast } from 'vant'
import { ref, computed } from 'vue'
import {
  getCylinderMessListByDeptIdForOverdue,
  addCylinderCheck
} from '@/api/steelCylinder'
import { cylinderRelationRemoveRef } from '@/api/cylinderManageUserHome'
import { getSelectList } from '@/api/common'
import { useLoadingMore } from '@/hooks/useLoadingMore'
import { useChecked } from '@/hooks/useChecked'
import { useSubmit, loading } from '@/hooks/useSubmit'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default {
  name: 'Submission', // 送检
  props: {
    title: {
      type: String
    },
    detail: {
      type: Object
    },
    method: {
      type: Function
    }
  },
  emits: ['finsh'],
  setup(props, { emit }) {
    const show = ref(false)
    const popup = ref(null)
    const store = useStore()
    const departId = computed(() => store.state.roleInfo.departId)
    const empId = computed(() => store.state.roleInfo.empId)
    const companyId = computed(() => store.state.roleInfo.companyId)
    const userId = computed(() => store.state.userInfo.id)
    const columns = ref([])
    const deptIdNew = ref('')
    const defaultVal = ref('')
    const data = useLoadingMore(getCylinderMessListByDeptIdForOverdue)
    const { getList, list, finished, loadingFail, pageParams } = data

    // 初始化list
    const init = (detail) => {
      console.log(detail.flag)
      list.value = []
      pageParams.deptId = detail.departId
      pageParams.companyId = detail.companyId
      pageParams.groupId = detail.groupId
      pageParams.flag = detail.flag
      pageParams.day = +detail.day
      pageParams.page = 1
      pageParams.pageNum = 15
      finished.value = false
      loadingFail.value = false
      getList()
    }

    const showPopup = async (detail) => {
      popup.value.show = true
      checked.value = []
      init(detail)
    }
    const hidePopup = () => {
      popup.value.show = false
    }
    // 下钻
    const router = useRouter()
    const handleComClick = (item) => {
      router.push(`/cylinderInfo/${item.gsCode}`)
    }
    // 选择钢瓶
    const { checkedAll, checked, checkboxGroup, handleCheckedAllClick } =
      useChecked(list)

    // 提交
    const handleSubmitClick = () => {
      if (checked.value.length) {
        const params = {
          companyId: companyId.value,
          empId: empId.value,
          codeArr: checked.value.join(',')
        }
        const { onSubmit } = useSubmit(addCylinderCheck, params, () => {
          hidePopup()
          emit('finsh')
        })
        onSubmit()
      } else {
        Toast('请选择钢瓶')
      }
    }
    // 退出原因
    const quitReason = ref('')
    const getReason = () => {
      getSelectList('30').then((res) => {
        columns.value = res.data
      })
    }
    getReason()
    // 钢瓶退出
    const handleSubmitClick2 = () => {
      if (!checked.value.length) {
        Toast('请选择钢瓶')
      } else {
        show.value = true
      }
    }
    const onConfirm = () => {
      show.value = false
      const params = {
        gsCodes: checked.value,
        operatorId: userId.value,
        quitReason: quitReason.value
      }
      const { onSubmit } = useSubmit(cylinderRelationRemoveRef, params, () => {
        hidePopup()
        emit('finsh')
      })
      onSubmit()
    }
    return {
      popup,
      showPopup,
      hidePopup,
      checkedAll,
      checked,
      checkboxGroup,
      handleCheckedAllClick,
      list,
      departId,
      handleSubmitClick,
      handleComClick,
      loading,
      show,
      columns,
      deptIdNew,
      defaultVal,
      ...data,
      quitReason,
      handleSubmitClick2,
      onConfirm
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  padding: 20px;
  background-color: #fff;
}
.title {
  padding: 16px;
  font-size: 16px;
  span {
    margin-right: 10px;
  }
}
.list {
  font-size: 14px;
  padding: 0 16px;
  .list-item {
    display: flex;
    align-items: center;
    padding: 10px;
    &__gsId {
      flex: 1;
    }
    &__residua-gas {
      margin: 0 50px 0 10px;
      width: 100px;
      text-align: right;
    }
  }
  .list-title {
    padding-bottom: 5px;
    margin-bottom: 5px;
  }
  .list-child {
    margin-bottom: 10px;
    &:nth-child(odd) {
      background-color: #fff;
    }
    &:nth-child(even) {
      background-color: #ededed;
    }
  }
}
.btn-fixed {
  margin: 16px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
